import isEqual from "lodash/isEqual";

export const dagdifferences = (
    jsonStr1: string,
    jsonStr2: string
  ): string[] => {
    const arr1 = JSON.parse(jsonStr1);
    const arr2 = JSON.parse(jsonStr2);

    const differences: string[] = [];
    const map2 = new Map(arr2.map((el: any) => [el.id, el]));

    for (const el1 of arr1) {

      if (el1.type == "DELETED-BOX") continue;

      const el2 = map2.get(el1.id);
      if (!el2) {
        differences.push(el1.id);
        continue;
      }

      const clean1 = JSON.parse(JSON.stringify(el1));
      const clean2 = JSON.parse(JSON.stringify(el2));

      if (clean1.meta) {
        delete clean1.meta.pause;
        delete clean1.meta.update;
        delete clean1.meta.ki;
      }
      if (clean2.meta) {
        delete clean2.meta.pause;
        delete clean2.meta.update;
        delete clean2.meta.ki;
      }
      delete clean1.out;
      delete clean2.out;

      if (!isEqual(clean1, clean2)) {
        differences.push(el1.id);
      }
    }

    return differences;
  };